import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Loader2 } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

/* One tap: resume exactly where the student stopped. */
export default function ContinueJourney() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/activity/recent").then((r) => {
      const item = (r.data || [])[0];
      navigate(item?.path || "/app/tadabbur/1", { replace: true });
    }).catch(() => navigate("/app/tadabbur/1", { replace: true }));
  }, [navigate]);
  return (
    <div className="max-w-md mx-auto py-24 text-center" data-testid="continue-journey-page">
      <Loader2 className="h-8 w-8 mx-auto animate-spin text-gold-600" />
      <div className="mt-4 font-display font-semibold text-forest-700">{t("continueJourney.takingYouBackToWhere")}</div>
    </div>
  );
}
